import {useState, lazy, Suspense} from 'react'
import '@/App.css'
import {BrowserRouter, Routes, Route} from 'react-router-dom'
import {Navbar} from './components/Navbar'
import {Hero} from './components/Hero'
import {Services} from './components/Services'
import {About} from './components/About'
import {Gallery} from './components/Gallery'
import {Testimonials} from './components/Testimonials'
import {Location} from './components/Location'
import {Footer} from './components/Footer'
import {BookingWizard} from './components/BookingWizard'
import {CookieBanner} from './components/CookieBanner'
import {useSiteContent} from './hooks/useSiteContent'
import {SiteContentContext} from './context/SiteContentContext'
import {siteConfig as fallbackConfig} from './config/siteConfig'

const PrivacyPage = lazy(() => import('./pages/PrivacyPage'))
const CookiesPage = lazy(() => import('./pages/CookiesPage'))

const Home = () => {
    const [bookingOpen, setBookingOpen] = useState(false)
    const [preselectedService, setPreselectedService] = useState(null)
    const {data, loading} = useSiteContent()

    const content = data || fallbackConfig

    const openBooking = (service = null) => {
        setPreselectedService(service)
        setBookingOpen(true)
    }

    if (loading) {
        return (
            <div
                data-testid="site-loading"
                className="min-h-screen bg-[#0a0a0a] flex items-center justify-center"
            >
                <div className="text-[#d4af37] text-xs tracking-[0.3em] uppercase animate-pulse">
                    A carregar…
                </div>
            </div>
        )
    }

    return (
        <SiteContentContext.Provider value={content}>
            <div className="min-h-screen bg-[#0a0a0a] text-[#f5f5f0]">
                <Navbar onReserveClick={() => openBooking()} />
                <main data-testid="main-content">
                    <Hero onReserveClick={() => openBooking()} />
                    <Services onSelectService={(s) => openBooking(s)} />
                    <About />
                    <Gallery />
                    <Testimonials />
                    <Location />
                </main>
                <Footer onReserveClick={() => openBooking()} />

                <BookingWizard
                    open={bookingOpen}
                    onClose={() => setBookingOpen(false)}
                    initialService={preselectedService}
                />
            </div>
        </SiteContentContext.Provider>
    )
}

const SiteShell = ({children}) => {
    const {data, loading} = useSiteContent()
    const content = data || fallbackConfig
    if (loading) {
        return (
            <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
                <div className="text-[#d4af37] text-xs tracking-[0.3em] uppercase animate-pulse">
                    A carregar…
                </div>
            </div>
        )
    }
    return (
        <SiteContentContext.Provider value={content}>
            {children}
        </SiteContentContext.Provider>
    )
}

const PageFallback = () => (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
        <div className="text-[#d4af37] text-xs tracking-[0.3em] uppercase animate-pulse">
            A carregar…
        </div>
    </div>
)

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Suspense fallback={<PageFallback />}>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route
                            path="/privacidade"
                            element={
                                <SiteShell>
                                    <PrivacyPage />
                                </SiteShell>
                            }
                        />
                        <Route
                            path="/cookies"
                            element={
                                <SiteShell>
                                    <CookiesPage />
                                </SiteShell>
                            }
                        />
                    </Routes>
                </Suspense>
                <CookieBanner />
            </BrowserRouter>
        </div>
    )
}

export default App
